import { FC } from "react";

/**
 * Eye Icon Props Interface
 * @interface EyeProps
 */
interface EyeProps {
  color?: string;
  size?: number;
}

const EditPencil: FC<EyeProps> = ({ color = "black", size = 24 }) => {
  return (
    <>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 17.7505V21.5005H6.75L17.81 10.4405L14.06 6.69055L3 17.7505ZM20.71 7.54055C21.1 7.15055 21.1 6.52055 20.71 6.13055L18.37 3.79055C17.98 3.40055 17.35 3.40055 16.96 3.79055L15.13 5.62055L18.88 9.37055L20.71 7.54055Z"
          fill={color}
        />
      </svg>
    </>
  );
};

export default EditPencil;
